export const APP_NAME = 'Rabbi Zera Shomshon'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
